let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fJVoi")).then(() => parcelRequire('h5RId'));